const scrollToTop = () => {
  const sTop = document.documentElement.scrollTop || document.body.scrollTop;
  if (sTop > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, sTop - sTop / 8);
  }
};
const objIsEmpty = (obj) => {
  if(!obj) return
  return Object.keys(obj).length === 0;
};
const isIOS = () => {
  // ios终端
  return /ipad|iPhone|Mac/i.test(window.navigator.userAgent);
};
const isAndroid = () => {
  // android终端
  return navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
};
export { scrollToTop, objIsEmpty, isIOS, isAndroid };
